import { FC, useCallback } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { SortOrder } from 'utils/array';
import SortableTable, { HeaderCell } from 'components/UI/Table/SortableTable';
import { Divert } from 'models/husqiotbus';
import { deleteDivert } from 'store/husqiotbusState/husqiotbusState';
import { IconType } from 'components/UI/Icon';

const headerCells: HeaderCell[] = [
  {
    title: 'husqiotbus.service_name',
    sortable: true,
  },
  {
    title: 'husqiotbus.direction',
    sortable: true,
  },
  {
    title: 'husqiotbus.filter',
    sortable: true,
  },
  {
    title: 'husqiotbus.environment',
    sortable: true,
  },
];

type Props = {
  diverts: Divert[];
};

const DivertTable: FC<Props> = ({ diverts }) => {
  const dispatch = useAppDispatch();

  // Fetch devices and navigate
  const onClick = useCallback(
    (link: string) => {
      if (link) {
        const [serviceName, type] = link.split('+');
        dispatch(deleteDivert(serviceName, type));
      }
    },
    [dispatch]
  );

  // Table rows
  const bodyRows = diverts.map(
    ({ serviceName, type, filter, environments }) => {
      return {
        serviceName,
        type,
        filter,
        environments: environments.toString(),
        link: `${serviceName}+${type}`,
      };
    }
  );
  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={bodyRows}
      onClick={onClick}
      sortOrder={SortOrder.Asc}
      sortIndex={2}
      emptyTextId="husqiotbus.no_diverts"
      rowIcon={IconType.Remove}
    />
  );
};

export default DivertTable;
